"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OauthDomainInvalidError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "OauthDomainInvalid";
const messageKey = "driver.oauth.error.domainInvalid";
class OauthDomainInvalidError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, constants_1.maxDomainPerOauth),
        });
    }
}
exports.OauthDomainInvalidError = OauthDomainInvalidError;
//# sourceMappingURL=oauthDomainInvalid.js.map